import React, { useState } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import { Button } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";
import AlertDialog from "../../ui/alerts/AlertDialog";
import { BACKGROUND_CHECK_STATUS } from "../../constants/ BACKGROUND_CHECK_STATUS";

export default function ApproveProvider({ id, handleSuccess }) {
  // Form Modal state
  const [showApprove, setShowApprove] = useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowApprove(false);
  const handleShow = () => setShowApprove(true);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // UPDATE
  const updateApprovalStatus = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data: userResp } = await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderDetail/${id}`,
        {
          method: "PATCH",
          data: {
            background_check_status: BACKGROUND_CHECK_STATUS.APPROVED,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      await axios(
        `https://ea1-dev.azurewebsites.net/api/userServiceProviderApprovals/${id}`,
        {
          method: "PATCH",
          data: {
            approved: true,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );

      if (userResp) {
        handleSuccess(userResp);
      }
      setData(data);
      setIsLoading(false);

      // Confirmation Modal Hide State (follow Delete method)
      setShowApprove(false);

      // Success Alert Popup
      setShowSuccess(true);
    } catch (e) {
      setIsLoading(false);

      // Confirmation Modal Hide State
      setShowApprove(false);

      // Error Alert Popup
      setShowError(true);
    }
  };

  const approveModal = (
    <Modal show={showApprove} backdrop='static' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Approve Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to approve this Provider? You can always reject on
        the Providers page.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='success'
          onClick={() => updateApprovalStatus(id)}
        >
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={"Provider successfully approved."}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error approving this Provider."}
      />
    </Modal>
  );

  return (
    <>
      <Button variant='outline-success' onClick={handleShow}>
        <Check size={25} />
        Approve
      </Button>
      {approveModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
